import { useState, useEffect } from "react";
import TextInput from "shared/@forms/TextInput";
import DateTimePicker from "shared/@forms/DateTimePicker";
import Button, { ButtonPurpose } from "shared/Button";
import { Row, Column, LabelGroup, Section } from "shared/layout";
import styles from "../index.module.css";
import { Auth } from "shared/@auth/Auth";
import { Event } from "Events/Components/useEvent";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

const formatDate = (utcDate, timeZone, abbr) => {
  if (!utcDate || !timeZone) return "N/A";
  const date = dayjs.utc(utcDate);
  if (!date.isValid()) return "Invalid Date";
  return date.tz(timeZone).format(`MMM DD, YYYY, hh:mm:ss A [${abbr}]`);
};

export default function Setup({ eventId, timezone, timezoneAbbr }) {
  const { eventData, updateGeneralInfo, refreshEvent } = Event.useContainer();
  const [isEditing, setIsEditing] = useState(false);
  const [syncId, setSyncId] = useState("");
  const [guidId, setGuidId] = useState(null);

  const safeTimeZone = timezone || "America/Los_Angeles";

  const checkInStartsOn =
    eventData?.checkInDates?.find(
      (date) => date.dateType === "CHECK IN - STARTS ON"
    )?.startsOn ||
    eventData?.newCheckInDates?.checkInStarts ||
    "";

  const checkInEndsOn =
    eventData?.checkInDates?.find(
      (date) => date.dateType === "CHECK IN - ENDS ON"
    )?.startsOn ||
    eventData?.newCheckInDates?.checkInEnds ||
    "";

  useEffect(() => {
    if (eventData) {
      setSyncId(eventData.scanningGuid?.guid || "");
      setGuidId(eventData.scanningGuid?.guidId || null);
    }
  }, [eventData]);

  // useEffect(() => {
  //   if (eventData) {
  //     // console.log("Refetched event data:", eventData);

  //     const checkInStart = eventData.checkInDates?.find(
  //       (date) => date.dateType === "CHECK IN - STARTS ON"
  //     );
  //     const checkInEnd = eventData.checkInDates?.find(
  //       (date) => date.dateType === "CHECK IN - ENDS ON"
  //     );

  //     setCheckInStartsOn({
  //       dateId: checkInStart?.dateID ?? null,
  //       startsOn: checkInStart?.startsOn || "",
  //     });

  //     setCheckInEndsOn({
  //       dateId: checkInEnd?.dateID ?? null,
  //       startsOn: checkInEnd?.startsOn || "",
  //     });

  //     setSyncId(eventData.scanningGuid?.guid || "");
  //     setGuidId(eventData.scanningGuid?.guidId || null);
  //   }
  // }, [eventData]);

  const handleSave = () => {
    if (!eventId || !updateGeneralInfo) return;

    const updatedInfo = {
      eventId: eventId,
      scanningGuid: {
        lngId: guidId,
        lngPurchaseTypeId: eventId,
        lngEventId: eventId,
        strGuid: syncId,
      },
      // checkInStartsOn: {
      //   dateId: checkInStartsOn.dateId,
      //   startsOn: checkInStartsOn.startsOn,
      // },
      // checkInEndsOn: {
      //   dateId: checkInEndsOn.dateId,
      //   startsOn: checkInEndsOn.startsOn,
      // },
    };

    updateGeneralInfo.mutate(updatedInfo, {
      onSuccess: () => {
        setIsEditing(false);
        refreshEvent();
      },
    });
  };

  return (
    <Section>
      <header>
        <h3>General Info</h3>
        <div className={styles.buttonsColumn}>
          {!isEditing ? (
            <Button size="small" onClick={() => setIsEditing(true)}>
              Edit
            </Button>
          ) : (
            <>
              <Button
                size="small"
                purpose={ButtonPurpose.save}
                onClick={handleSave}
              >
                Save
              </Button>
              <Button size="small" onClick={() => setIsEditing(false)}>
                Cancel
              </Button>
            </>
          )}
        </div>
      </header>

      <Row>
        <Column>
          <LabelGroup title="Sync ID">
            {!isEditing ? (
              syncId || "Default ID"
            ) : (
              <TextInput
                value={syncId || ""}
                onChange={(e) => setSyncId(e.target.value)}
              />
            )}
          </LabelGroup>
        </Column>

        {/* <Column>
          <LabelGroup title="Check In - Starts on">
            {!isEditing ? (
              formatDate(checkInStartsOn.startsOn, timezone, timezoneAbbr)
            ) : (
              <DateTimePicker
                timeZone={timezone}
                value={checkInStartsOn.startsOn || ""}
                onChange={(date) =>
                  setCheckInStartsOn((prev) => ({ ...prev, startsOn: date }))
                }
              />
            )}
          </LabelGroup>
        </Column>

        <Column>
          <LabelGroup title="Check In - Ends on">
            {!isEditing ? (
              // checkInEndsOn.startsOn &&
              formatDate(checkInEndsOn.startsOn, timezone, timezoneAbbr)
            ) : (
              <DateTimePicker
                timeZone={timezone}
                value={checkInEndsOn.startsOn || ""}
                onChange={(date) =>
                  setCheckInEndsOn((prev) => ({ ...prev, startsOn: date }))
                }
              />
            )}
          </LabelGroup>
        </Column> */}

        <Column>
          <LabelGroup title="Check In - Starts on">
            {formatDate(checkInStartsOn, timezone, timezoneAbbr)}
          </LabelGroup>
        </Column>

        <Column>
          <LabelGroup title="Check In - Ends on">
            {formatDate(checkInEndsOn, timezone, timezoneAbbr)}
          </LabelGroup>
        </Column>
      </Row>
    </Section>
  );
}
